import { BankAccountType } from '../enums/bank-account-type.enum';
import { StripeBankAccountStatus } from '../enums/stripe-bank-account-status.enum';

export interface BankAccount {
  id: string;
  bankName: string;
  routingNumberMasked: string; // masked, never full number
  accountNumberMasked: string; // masked, never full number
  /** @deprecated Use routingNumberMasked — kept for backward compat */
  routingNumber?: string;
  /** @deprecated Use accountNumberMasked — kept for backward compat */
  accountNumber?: string;
  accountType: BankAccountType;
  isPrimary: boolean;
  isStripeLinked: boolean;
  isVerified: boolean;
  verificationDate: string | null;
  stripeExternalAccountId: string | null;
  stripeBankAccountStatus: StripeBankAccountStatus | null;
}

export interface CreateContractorBankAccount {
  bankName: string; // required, maxLength: 100
  routingNumber: string; // required, maxLength: 9, regex: ^\d{9}$
  accountNumber: string; // required, maxLength: 20
  accountType: BankAccountType; // required, default: "checking"
}

export interface UpdateContractorBankAccount {
  bankName?: string; // optional, maxLength: 100
  routingNumber?: string; // optional, maxLength: 9, regex: ^\d{9}$
  accountNumber?: string; // optional, maxLength: 20
  accountType?: BankAccountType; // optional
}
